



















import {Component, Vue} from 'vue-property-decorator'
import {Inject} from "typescript-ioc";
import CompanyLocationApi from "@/api/CompanyLocationApi";
import CompanyLocation from "@/model/CompanyLocation";
import companyLocationModule from "@/store/module/CompanyLocationModule";
import _ from 'lodash'
import {Event} from "@/event/Event";

@Component({})
export default class Location extends Vue {

    @Inject
    private clocationApi!: CompanyLocationApi

    private clocationId = "-1"

    private clocations: Array<CompanyLocation> = []

    private async created() {
        await this.getClocations()
    }

    private async getClocations() {
        this.clocations = await this.clocationApi.list()
        if (this.clocations.length > 0) {
            const clocation = this.clocations[0]
            this.clocationId = clocation.id
            companyLocationModule.activate(clocation)
        }
    }

    private handleClocationChange() {
        const clocation = _.find(this.clocations, {id: this.clocationId}) as CompanyLocation
        companyLocationModule.activate(clocation)
        this.$bus.$emit(Event.COMPANY_LOCATION_CHANGE, clocation)
    }
}
